<template>
  <div class="p-4">
    <div class="flex justify-between items-center mb-4">
      <div class="flex space-x-2">
        <button
          @click="openAddModal"
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
        >
          Добавить единицу
        </button>
        <button
          @click="fetchUnitsFromOneC"
          :disabled="loading"
          class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 disabled:opacity-50"
        >
          {{ loading ? 'Загрузка...' : 'Запросить из 1С' }}
        </button>
      </div>
      <router-link
        :to="{ name: 'Products' }"
        class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        Продукция
      </router-link>
    </div>

    <div v-if="loading && units.length === 0" class="flex justify-center items-center h-40">
      <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
    </div>

    <table v-else class="w-full border-collapse bg-white shadow-md">
      <thead class="bg-gray-100">
        <tr>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">#</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Имя</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Короткое имя</th>
          <!-- <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Целочисленный</th> -->
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">GUID 1С</th>
          <th class="px-4 py-2 text-left text-sm font-medium text-gray-700">Действия</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="unit in units" :key="unit.id" class="border-b hover:bg-gray-50">
          <td class="px-4 py-2 text-sm text-gray-700">{{ unit.id }}</td>
          <td class="px-4 py-2 text-sm text-gray-700">{{ unit.name }}</td>
          <td class="px-4 py-2 text-sm text-gray-700">{{ unit.short_name }}</td>
          <!-- <td class="px-4 py-2 text-sm text-gray-700">{{ unit.is_integer ? 'Да' : 'Нет' }}</td> -->
          <td class="px-4 py-2 text-sm text-gray-500 font-mono text-xs">{{ unit.guid || '-' }}</td>
          <td class="px-4 py-2 flex gap-2">
            <router-link
              :to="{ name: 'ProductUnitEdit', params: { id: unit.id } }"
              class="px-2 py-1 text-sm font-medium text-blue-600 bg-blue-100 rounded-md hover:bg-blue-200"
            >Редактировать</router-link>
            <button
              @click="confirmDelete(unit.id)"
              class="px-2 py-1 text-sm font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200"
            >
              Удалить
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Модалка создания -->
    <div v-if="showAddModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
        <h2 class="text-lg font-bold mb-4">Добавить единицу измерения</h2>
        <div class="space-y-3">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Полное имя</label>
            <input v-model="newUnit.name" type="text" class="w-full px-3 py-2 border rounded-md" placeholder="Миллиметр" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Короткое имя</label>
            <input v-model="newUnit.short_name" type="text" class="w-full px-3 py-2 border rounded-md" placeholder="мм" />
          </div>
          <div>
            <label class="flex items-center">
              <input v-model="newUnit.is_integer" type="checkbox" class="mr-2" />
              <span class="text-sm text-gray-700">Целочисленный учёт</span>
            </label>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">GUID 1С (необязательно)</label>
            <input v-model="newUnit.guid" type="text" class="w-full px-3 py-2 border rounded-md" placeholder="" />
          </div>
        </div>
        <div class="flex justify-end gap-2 mt-4">
          <button @click="showAddModal = false" class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md">Отмена</button>
          <button @click="createUnit" class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md">Создать</button>
        </div>
      </div>
    </div>

    <!-- Модалка подтверждения удаления -->
    <div v-if="deleteModalUnitId" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
        <h2 class="text-lg font-bold mb-4">Подтвердите удаление</h2>
        <p class="text-sm text-gray-700 mb-4">Вы уверены, что хотите удалить эту единицу измерения?</p>
        <div class="flex justify-end space-x-2">
          <button @click="deleteModalUnitId = null" class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md">Отмена</button>
          <button @click="proceedDelete" class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md">Удалить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProductUnitsIndex',
  data() {
    return {
      units: [],
      loading: false,
      showAddModal: false,
      deleteModalUnitId: null,
      newUnit: {
        name: '',
        short_name: '',
        is_integer: false,
        guid: ''
      }
    };
  },
  created() {
    this.getAll();
  },
  methods: {
    getAll() {
      this.loading = true;
      axios.post('/api/product-unit/getAll')
        .then(({ data }) => {
          this.units = data.data || [];
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false; });
    },
    fetchUnitsFromOneC() {
      this.loading = true;
      axios.post('/api/oneC/getProductUnits')
        .then(() => {
          if (this.$root.$toast?.success) this.$root.$toast.success('Запрос отправлен');
          this.getAll();
        })
        .catch(err => {
          console.error(err);
          if (this.$root.$toast?.error) this.$root.$toast.error('Ошибка запроса');
        })
        .finally(() => { this.loading = false; });
    },
    openAddModal() {
      this.newUnit = { name: '', short_name: '', is_integer: false, guid: '' };
      this.showAddModal = true;
    },
    createUnit() {
      if (!this.newUnit.name || !this.newUnit.short_name) {
        if (this.$root.$toast?.error) this.$root.$toast.error('Заполните имя и короткое имя');
        return;
      }
      axios.post('/api/product-unit/create', this.newUnit)
        .then(() => {
          this.showAddModal = false;
          this.getAll();
          if (this.$root.$toast?.success) this.$root.$toast.success('Единица создана');
        })
        .catch(err => {
          if (this.$root.$toast?.error) this.$root.$toast.error(err.response?.data?.message || 'Ошибка');
        });
    },
    confirmDelete(id) {
      this.deleteModalUnitId = id;
    },
    proceedDelete() {
      if (!this.deleteModalUnitId) return;
      axios.post('/api/product-unit/delete', { id: this.deleteModalUnitId })
        .then(() => {
          this.deleteModalUnitId = null;
          this.getAll();
          if (this.$root.$toast?.success) this.$root.$toast.success('Единица удалена');
        })
        .catch(err => {
          if (this.$root.$toast?.error) this.$root.$toast.error(err.response?.data?.message || 'Ошибка');
        });
    }
  }
};
</script>
